module.exports = __webpack_public_path__ + "static/media/asana.d4e57661.svg";